// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__dGooe","right":"styles_right__3UNau"};